import { useMemo } from 'react';

import { useGetProductCatalogQuery } from '@/api/hooks/queries/use-get-product-catalog-query';
import { useSessionStore } from '@/hooks/use-session-store/use-session-store';
import type { Product } from '@/types/product.type';

type UseReferrerProductResult = {
  referrerProductId: string | null;
  product: Product | undefined;
  isLoading: boolean;
  isNotFound: boolean;
};

export function useReferrerProduct(): UseReferrerProductResult {
  const referrerProductId = useSessionStore((state) => state.referrerProductId);
  const catalogQuery = useGetProductCatalogQuery();

  const product = useMemo(
    () => catalogQuery.data?.find((catalogProduct) => catalogProduct.uuid === referrerProductId),
    [catalogQuery.data, referrerProductId]
  );

  return {
    referrerProductId,
    product,
    isLoading: catalogQuery.isLoading,
    // Gated on `isSuccess` so a failed catalog request (recoverable) isn't
    // mistaken for an invalid link and doesn't clear `referrerProductId`.
    isNotFound: Boolean(referrerProductId) && catalogQuery.isSuccess && !product,
  };
}
